import React, { useState } from 'react';
import { ChevronIcon } from "../../../icons/icons";
import './UtilitiesBox.scss';

const UtilitiesBox = ({ title, icon: Icon, children }) => {
  const [isOpen, setIsOpen] = useState(true);

  const toggleBox = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="collapse-expand-box">
      <div className={`utility-header ${isOpen ? 'open' : 'closed'}`} onClick={toggleBox}>
        <div className="utility-heading">
          <Icon /> {title}
        </div>
        <div className={`chevron-icon ${isOpen ? 'chevron-open' : 'chevron-closed'}`}>
          <ChevronIcon />
        </div>
      </div>
      <div className={`utility-content ${isOpen ? 'open' : 'closed'}`}>
        {children}
      </div>
    </div>
  );
};

export default UtilitiesBox;